import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import TunnelResultPage from '@/components/TunnelResultPage/TunnelResultPage';
import { useAuth } from '@/hooks/useAuth';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

export const FaireVersementFail: React.FC = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  useEffect(() => {
    if (user?.id && user.type && user.success) {
      TRACKING_INSTANCE.setTcVars({
        page_nom: 'erreur versement contact conseiller',
        page_template: 'espace client',
        user_id: user.id,
        user_client: user.type === 'Client',
        user_connexion: user.success,
        user_statut_contrat: sessionStorage.getItem('user_statut_contrat'),
        tunnel_produit: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratNomProduit,
        tunnel_metier: 'espace client placement',
        tunnel_sous_metier: JSON.parse(sessionStorage.getItem('parcoursVersementData') || '{}').contratFamille,
        tunnel_categorie_produit: 'parcours de versement',
      });
      void TRACKING_INSTANCE.triggerEvent('page', undefined, {
        event_id: 'page',
        event_categorie: 'affichage espace client',
        event_nom: 'erreur versement contact conseiller',
        event_page: 'erreur versement',
      });
    }
  }, [user?.id, user?.type, user?.success]);

  const handleContactConseiller = () => {
    const versementData = JSON.parse(sessionStorage.getItem('parcoursVersementData') ?? '{}');
    void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
      event_id: 'clic',
      event_categorie: 'clic',
      event_metier: 'espace client placement',
      event_nom: 'contacter un conseiller',
      event_detail_1: 'cta',
      event_detail_2: `${versementData.contratFamille} - ${versementData.contratNomProduit}`,
    });
    document.location.href = 'tel:+900300400';
  };

  return (
    <TunnelResultPage
      iconName="warning-solide"
      iconVariant="error"
      title={t('faireVersementFail.title')}
      subtitles={[t('faireVersementFail.subtitle')]}
      ctaLabel={t('faireVersementFail.cta')}
      onCtaClick={handleContactConseiller}
    />
  );
};
